import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetUpdatedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetUpdatedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetUpdatedEvent.type = 'com.treeplotter.api.asset.updated.v1';
EventRegistry.register(AssetUpdatedEvent.type, AssetUpdatedEvent);
//# sourceMappingURL=asset-updated.event.js.map